import React from 'react';
import ContainerTemplate from '../../../widgets/template/Container';
import EstudiantesDocenteView from './EstudiantesDocenteView';
import * as ROUTES from '../../../router/Routes';

const EstudiantesDocenteModule = () => {
  return (
    <ContainerTemplate active={ROUTES.estudiantesDocentes} routes={[]}>
      <EstudiantesDocenteView />
    </ContainerTemplate>
  );
};

export default EstudiantesDocenteModule;
